import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {UploadedFile} from '@ui/utils/files/uploaded-file';
import {Restrictions} from '@ui/utils/files/validate-file';
import {FileUpload, FileUploadStoreOptions} from './file-upload-store';
import {UploadStrategyConfig} from './strategy/upload-strategy';

export function createUpload(
  file: UploadedFile | File,
  strategyConfig: UploadStrategyConfig,
  storeOptions: FileUploadStoreOptions | undefined,
): FileUpload {
  let uploadedFile =
    file instanceof UploadedFile ? file : new UploadedFile(file);
  if (storeOptions?.modifyUploadedFile) {
    uploadedFile = storeOptions.modifyUploadedFile(uploadedFile);
  }
  return {
    file: uploadedFile,
    percentage: 0,
    bytesUploaded: 0,
    status: 'pending',
    options: {
      ...strategyConfig,
      restrictions: restrictionsFromConfig(strategyConfig),
    },
  };
}

export function restrictionsFromConfig(
  config: UploadStrategyConfig,
): Restrictions | null {
  if (config.restrictions) {
    return config.restrictions;
  }

  const uploadType = getBootstrapData()?.uploading_types[config.uploadType];
  return restrictionsFromRules(uploadType);
}

/**
 * Uploader restrictions from effective upload rules
 * (max_file_size null = Unlimited, accept [] = any type).
 */
export function restrictionsFromRules(
  rules?: {max_file_size?: number | string | null; accept?: string[] | null} | null,
): Restrictions | null {
  if (rules && (rules.max_file_size || rules.accept?.length)) {
    return {
      maxFileSize: rules.max_file_size
        ? parseInt(`${rules.max_file_size}`)
        : undefined,
      allowedFileTypes: rules.accept?.length ? rules.accept.map(function (type) {
        switch (type) {
          case 'image':
            return 'image/*';
          case 'video':
            return 'video/*';
          case 'audio':
            return 'audio/*';
          default:
            return type;
        }
      }) : undefined,
    };
  }

  return null;
}
